import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh, setProfile } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    (async () => {
      const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
      const sid = params.get("session_id");
      if (!sid) { nav("/auth"); return; }
      try {
        await api.post("/auth/google-session", { session_id: sid });
        window.history.replaceState(null, "", window.location.pathname);
        const raw = sessionStorage.getItem("mynsight_preview");
        if (raw) {
          try {
            const { form } = JSON.parse(raw);
            const { data } = await api.post("/profiles", form);
            sessionStorage.removeItem("mynsight_preview");
            setProfile(data);
            await refresh();
            toast.success("Welcome. Your companion remembers you now.");
            nav("/dashboard");
            return;
          } catch (e) { console.error("preview profile create failed, continuing:", e); }
        }
        const { data } = await api.get("/my-profile");
        await refresh();
        nav(data ? "/home" : "/setup");
      } catch {
        toast.error("Google sign-in failed. Try again.");
        nav("/auth");
      }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen star-field celestial flex flex-col items-center justify-center gap-4">
      <Loader2 className="animate-spin text-primary" size={28} />
      <p className="font-mono text-xs uppercase tracking-widest text-muted-foreground">Aligning your stars…</p>
    </div>
  );
}
